<template>
    <NuxtLink v-slot="{href, navigate}" :to="$withLocalePrefix('/resources/search')" custom>
        <VJoyIconButton
            v-if="isGhostIconButton"
            variant="ghost"
            :class="{'rc-search-cta': true, [buttonClass ?? '']: !!buttonClass}"
            icon="search"
            :href="href"
            size="small"
            @click="navigate"
        />
        <VJoyButton
            v-else
            variant="secondary"
            :class="{'rc-search-cta': true, [buttonClass ?? '']: !!buttonClass}"
            icon="search"
            :href="href"
            size="small"
            @click="navigate"
        >
            <span class="message">{{ message }}</span>
        </VJoyButton>
    </NuxtLink>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useMediaQuery} from '@malt/utils';
    import {VJoyButton, VJoyIconButton} from '@maltjoy/core-vue';

    defineProps<{message: string; buttonClass?: string}>();

    const {matchMedia} = useMediaQuery();
    const isGhostIconButton = computed(() => (matchMedia.value.max.Sm || matchMedia.value.min.Md) && !matchMedia.value.min.Lg);
</script>

<style lang="scss">
    .rc-search-cta {
        padding: var(--joy-core-spacing-2) var(--joy-core-spacing-5) var(--joy-core-spacing-2) var(--joy-core-spacing-5) !important;

        .icon-search {
            position: relative;
            top: 2px;
        }
    }
</style>
